import Header from "./Header";
import ContactForm from "./ContactForm";
import Footer from "./Footer";
import task from '../images/task-automation.png';
import communication from '../images/communication-automation.png';
import financial from '../images/financial-automation.png';
import workflow from '../images/workflow-automation.png';
import custom from '../images/custom-automation.png';
import ai from '../images/ai-integrations.png';
import apps from '../images/custom-applications.png';
import LazyLoad from "./LazyLoad";

function Services() {

    return (
        <div className={"services page"}>
            <Header/>
            <div className={"page-heading"}>SERVICES</div>
            <div className={"content"}>
                <div className={"services-page-text"}>
                    <div className={"section open"}>
                        <p className={"section-content"}>
                            Rexius Algorithms builds AI integrations, custom applications, and automation that take
                            routine work off your plate. Every solution is designed around your needs, from a single
                            scheduled task to a full application.
                            <br/>
                            We also take care of hosting and maintenance, ensuring seamless operations without the need
                            for constant manual oversight.
                            <br/>
                            Here are the services we offer:
                        </p>
                    </div>
                    <div className={"section open"}>
                        <div className={"services-section"}>
                            <div className={"service-section scale-up"}>
                                <img className={"service-section-service-image enclosed-image"} src={ai}
                                     alt={"ai-integrations"}/>
                                <div className={"service-section-task-name"}>AI Integrations</div>
                                <div className={"service-section-learn-more"}>
                                    <a href="/services/ai" className="learn-more">Learn More</a>
                                </div>
                            </div>
                            <div className={"service-section scale-up"}>
                                <img className={"service-section-service-image enclosed-image"} src={apps}
                                     alt={"custom-applications"}/>
                                <div className={"service-section-task-name"}>Custom Applications</div>
                                <div className={"service-section-learn-more"}>
                                    <a href="/services/apps" className="learn-more">Learn More</a>
                                </div>
                            </div>
                            <div className={"service-section scale-up"}>
                                <img className={"service-section-service-image "} src={task} alt={"task-automation"}/>
                                <div className={"service-section-task-name"}>Task Automation</div>
                                <div className={"service-section-learn-more"}>
                                    <a href="/services/task" className="learn-more">Learn More</a>
                                </div>
                            </div>
                            <div className={"service-section scale-up"}>
                                <img className={"service-section-service-image enclosed-image"} src={communication}
                                     alt={"communication-automation"}/>
                                <div className={"service-section-task-name"}>Communication Automation</div>
                                <div className={"service-section-learn-more"}>
                                    <a href="/services/communication" className="learn-more">Learn More</a>
                                </div>
                            </div>
                            <div className={"service-section scale-up"}>
                                <img className={"service-section-service-image enclosed-image"} src={financial}
                                     alt={"financial-automation"}/>
                                <div className={"service-section-task-name"}>Financial Automation</div>
                                <div className={"service-section-learn-more"}>
                                    <a href="/services/financial" className="learn-more">Learn More</a>
                                </div>
                            </div>
                            <div className={"service-section scale-up"}>
                                <img className={"service-section-service-image enclosed-image"} src={workflow}
                                     alt={"workflow-automation"}/>
                                <div className={"service-section-task-name"}>Workflow Automation</div>
                                <div className={"service-section-learn-more"}>
                                    <a href="/services/workflow" className="learn-more">Learn More</a>
                                </div>
                            </div>
                            <div className={"service-section scale-up"}>
                                <img className={"service-section-service-image enclosed-image"} src={custom}
                                     alt={"custom-automation"}/>
                                <div className={"service-section-task-name"}>Custom Automation</div>
                                <div className={"service-section-learn-more"}>
                                    <a href="/services/custom" className="learn-more">Learn More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LazyLoad>
                    <ContactForm/>
                </LazyLoad>
            </div>
            <Footer/>
        </div>
    )

}

export default Services;